import { useEffect, useState } from 'react';
import { useStore } from './index';
import { PageMode } from './types';
import { useDigitalStore } from './digital';

export const useAutoSilent = () => {
  const { setMode  } = useStore();
  const isIdle = useDigitalStore((state) => state.isIdle);
  const [lastSetTime, setLastSetTime] = useState<number>(Date.now());

  // 监听点击事件
  useEffect(() => {
    const handleClick = () => {
      setLastSetTime(Date.now());
    };

    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);

  // 监听数字人状态变化
  // useEffect(() => {
  //   setLastSetTime(Date.now());
  // }, [isIdle]);

  // 监听 lastSetTime 变化，重置定时器
  useEffect(() => {
    if(!isIdle)return;
    // console.log('resetTimer');
    
    const threeMinutes = 30 * 60 * 1000;
    const timer = setTimeout(() => {
      setMode(PageMode.SILENT);
    }, threeMinutes);
    return () => clearTimeout(timer);
  }, [lastSetTime,isIdle]);

  // 重置时间的方法
  const reset = () => {
    setLastSetTime(Date.now());
  };

  return {
    reset
  };
}; 